<template>
    <CqModal :showModal="showModal">
        <p>Om gebruik te maken van het planbord, moet u uw klantnaam invoeren.</p>
        <CqTextInput label="Klantnaam" v-model="globalTenant" />
        <CqButtonBar>
            <CqButton primary label="Ga verder" :disabled="globalTenant.length === 0" @click="$emit('confirmAction')" margin="no-top-bottom" />
        </CqButtonBar>
    </CqModal>
</template>

<script lang="ts">
    import {Vue, Model, Component, Prop} from 'vue-facing-decorator';
    import {CqTextInput, CqModal, CqButtonBar, CqButton} from '@cquential/ui';

    @Component({
        components: {
            CqModal,
            CqTextInput,
            CqButtonBar,
            CqButton,
        },
        emits: ['confirmAction'],
    })
    export default class AskTenantModal extends Vue {
        @Model() public globalTenant!: string;
        @Prop({type: Boolean}) public showModal!: boolean;
    }
</script>
